import React from 'react';
import { Page } from './page';

import { GameInfo } from '../components/gameInfo';
import { Restore } from '../components/restore';

import Player from '../functions/player';

var nameDistributions = [
  'Groenburgh',
  'Bronnendal',
  'Bizniz Company',
  'Corporation Int.',
  'Wellectric',
  'Sonnelect',
  'Overheid',
  'De markt',
  'Spelleider'
];

export class Preparation extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      screenID: 1,
      screenDuration: 0,
      playerAmount: 0,
      playerEmail: '',
      partOfGame: 2,
      timerOver: false,
    }
  }

  componentWillMount(){
    const currentPart = Player.getData('partOfGame');
    this.setState({
      partOfGame: currentPart,
    });

    if (!Player.getData('playerAmount')) {
      let defaultData = [2,	2,	2,	2,	2,	2,	1,	2, 1];
      Player.storeData('playerAmount', defaultData);
    }

    this.setState({
      playerEmail: Player.getData('playerEmail'),
      playerAmount: Player.getData('playerAmount'),
      screenDuration: Player.getData('playerTime'),
    });

    var currentLocation = this.props.location.pathname;
    Player.storeData('localRoute', currentLocation);
  }

  nextRound = () => {
    this.refs.GameInfo.nextRound();
    return;
  }

  createTable = () => {
    let table = [];

    if (nameDistributions !== 0 | nameDistributions !== '0' ) {
      if (this.state.playerAmount !== 0 | this.state.playerAmount !== '0') {
        for (let i = 0; i < nameDistributions.length; i++) {
          let children = [];

          const listValues = nameDistributions,
                listDistri = this.state.playerAmount;

          children.push(<td className="name" key={'name_' + i} > { listValues[i] } </td>);
          children.push(<td className="numPlayers" key={'val_' + i} > { listDistri[i] } </td>);
          children.push(<td className="key" key={'key_' + i} >leerlingen</td>);

          table.push(<tr key={(i + 1).toString()}>{ children }</tr>)
        }
      } else {
        table.push('error')
      }
    } else {
      table.push('error')
    }
    return table
  };

  render() {
    return (
      <Page pageTitle="Inlezen">
      <Restore />
        <div className="inlezen">
          <h2>Maak groepjes en bereid je voor!</h2>
          <table className="prepTable">
            <tbody>
              { this.createTable() }
            </tbody>
          </table>
          <div className="pageLink">
            <a target="_blank" rel="noopener noreferrer" href="https://youvegotthepower.nl/files/pdf/instructiebladen.pdf">Download instructiebladen met spelregels (pdf)</a>
          </div>
          <div className="pageLink">
            <a target="_blank" rel="noopener noreferrer" href="https://youvegotthepower.nl/files/pdf/paspoort.pdf">Download leerlingenpaspoort (pdf)</a>
          </div>
          <div className="pageLink">
            <a target="_blank" rel="noopener noreferrer" href="https://youvegotthepower.nl/files/pdf/naambordjes.pdf">Download naambadges (pdf)</a>
          </div>
        </div>
        <div className="gameInfo-Timeonly posright">
          <GameInfo ref="GameInfo" part={this.state.partOfGame} getGameScreen={() => {return this.props.location.pathname}}  />
          <button className="bigButton" onClick={this.nextRound}>Volgende</button>
        </div>
      </Page>
    )
  };
}



// WEBPACK FOOTER //
// ./src/pages/preparation.js